import React, { FunctionComponent } from "react"

interface CircleProgressProps {
	percent: number
}

const CircleProgress: FunctionComponent<CircleProgressProps> = ({ percent }) => {
	const size = 120
	const strokeWidth = 8
	const radius = (size - strokeWidth) / 2
	const circumference = 2 * Math.PI * radius
	let offset = circumference * (1 - percent / 100)
	if (percent > 100)
		offset = 0 

	return (
		<svg width={size} height={size}>
			<circle cx={size / 2} cy={size / 2} r={radius} stroke='#eee' strokeWidth={strokeWidth} fill='none' />
			<circle
				cx={size / 2}
				cy={size / 2}
				r={radius}
				stroke='#0065BD'
				strokeWidth={strokeWidth}
				fill='none'
				strokeDasharray={circumference}
				strokeDashoffset={offset}
				transform={`rotate(-90 ${size / 2} ${size / 2})`}
			/>
			<text x='50%' y='50%' dominantBaseline='middle' textAnchor='middle' fontSize='18' fill='#7F7F7F'>
				{`${Math.round(percent)}%`}
			</text>
		</svg>
	)
}

export default CircleProgress
